import { useMemo } from 'react';

interface ListingBadge {
  label: string;
  variant: 'default' | 'secondary' | 'destructive' | 'outline';
  icon?: string;
}

interface UseListingBadgesProps {
  createdAt: string;
  viewCount?: number;
  isVerified?: boolean;
  autoPromoted?: boolean;
  autoPromotionEnd?: string;
  certifiedVehicle?: boolean;
  premiumPromoted?: boolean;
}

export const useListingBadges = ({
  createdAt,
  viewCount = 0,
  isVerified = false,
  autoPromoted = false,
  autoPromotionEnd,
  certifiedVehicle = false,
  premiumPromoted = false,
}: UseListingBadgesProps) => {
  const badges = useMemo(() => {
    const result: ListingBadge[] = [];
    const now = new Date();
    const created = new Date(createdAt);
    const hoursSinceCreation = (now.getTime() - created.getTime()) / (1000 * 60 * 60);

    // Premium promovat
    if (premiumPromoted) {
      result.push({
        label: '⭐ Premium',
        variant: 'default',
      });
    }

    // Dealer verificat
    if (isVerified) {
      result.push({
        label: '✓ Verificat',
        variant: 'outline',
      });
    }

    // Vehicul certificat
    if (certifiedVehicle) {
      result.push({
        label: '🏆 Certificat',
        variant: 'secondary',
      });
    }

    // Nou (primele 24h)
    if (hoursSinceCreation <= 24) {
      result.push({
        label: 'Nou',
        variant: 'default',
      });
    }

    // Auto-promovat (primele 48h)
    if (autoPromoted && autoPromotionEnd) {
      const promoEnd = new Date(autoPromotionEnd);
      if (promoEnd > now) {
        result.push({
          label: 'Premium',
          variant: 'default',
        });
      }
    }

    return result;
  }, [createdAt, viewCount, isVerified, autoPromoted, autoPromotionEnd, certifiedVehicle, premiumPromoted]);

  return badges;
};
